import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import HabboImagerPro from "../../components/HybridProImager";
import { FontScaleContext } from "../../App";

function General({ userData }) {
    const fontScale = useContext(FontScaleContext);

    if (!userData || !userData.hasStaffRole) {
        return <Navigate to="/" replace />;
    }

    return <div style={{ zoom: 1 / fontScale }}><HabboImagerPro userData={userData} config={{ icon: "/img/icons/icon_343.png" }} /></div>;
}

export default General;